import React from 'react';
import { X, Phone, Mail, MapPin, Clock, Star, UserCheck, Award, Languages } from 'lucide-react';
import Avatar from '../common/Avatar';

const DoctorDetailsModalSimple = ({ doctor, isOpen, onClose }) => {
  if (!isOpen || !doctor) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Détails du Médecin</h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-start space-x-6">
            <Avatar
              src={doctor.user?.avatar}
              alt={doctor.user?.name || 'Médecin'}
              name={doctor.user?.name || 'Médecin'}
              size="3xl"
            />
            <div className="flex-1">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-2xl font-bold text-gray-900">{doctor.user?.name || 'Médecin'}</h3>
                <div className="flex items-center space-x-1">
                  <Star className="h-5 w-5 text-yellow-400 fill-current" />
                  <span className="text-lg font-semibold text-gray-900">{doctor.rating}</span>
                </div>
              </div>
              
              <p className="text-xl text-primary-600 font-semibold mb-2">{doctor.specialty}</p>
              <p className="text-gray-600 mb-4">{doctor.hospital}</p>
              
              <div className="flex items-center mb-2">
                <div className={`w-3 h-3 rounded-full mr-3 ${doctor.isOnline ? 'bg-green-500' : 'bg-gray-400'}`}></div>
                <span className="text-gray-600">
                  {doctor.isOnline ? 'En ligne' : 'Hors ligne'}
                </span>
              </div>
            </div>
          </div>

          {/* Informations détaillées */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-900 mb-4">Informations Personnelles</h4>
              
              <div className="flex items-center text-gray-600">
                <Phone className="h-5 w-5 mr-3 text-primary-600" />
                <span>{doctor.user?.phone || 'N/A'}</span>
              </div>
              
              <div className="flex items-center text-gray-600">
                <Mail className="h-5 w-5 mr-3 text-primary-600" />
                <span>{doctor.user?.email || 'N/A'}</span>
              </div>
              
              <div className="flex items-center text-gray-600">
                <MapPin className="h-5 w-5 mr-3 text-primary-600" />
                <span>{doctor.zone || 'N/A'}</span>
              </div>
              
              <div className="flex items-center text-gray-600">
                <Clock className="h-5 w-5 mr-3 text-primary-600" />
                <span>{doctor.experience || 'N/A'}</span>
              </div>
            </div>

            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-900 mb-4">Informations Professionnelles</h4>
              
              {doctor.licenseNumber && (
                <div className="flex items-center text-gray-600">
                  <Award className="h-5 w-5 mr-3 text-primary-600" />
                  <span>Licence: {doctor.licenseNumber}</span>
                </div>
              )}
              
              {doctor.qualifications && (
                <div className="text-gray-600">
                  <div className="flex items-start">
                    <Award className="h-5 w-5 mr-3 text-primary-600 mt-1" />
                    <div>
                      <p className="font-medium mb-1">Qualifications:</p>
                      <p className="text-sm">{doctor.qualifications}</p>
                    </div>
                  </div>
                </div>
              )}
              
              {doctor.languages && (
                <div className="text-gray-600">
                  <div className="flex items-start">
                    <Languages className="h-5 w-5 mr-3 text-primary-600 mt-1" />
                    <div>
                      <p className="font-medium mb-1">Langues:</p>
                      <p className="text-sm">{doctor.languages}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Actions */}
          <div className="flex space-x-4 mt-8 pt-6 border-t border-gray-200">
            <button className="flex-1 bg-primary-600 hover:bg-primary-700 text-white py-3 px-6 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200">
              <Phone className="h-5 w-5" />
              <span>Appeler</span>
            </button>
            <button className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200">
              <UserCheck className="h-5 w-5" />
              <span>Prendre Rendez-vous</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorDetailsModalSimple;
